module.exports = function (e) {
  var t = {};
  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
      return e[t];
    }.bind(null, o));
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.anime = t.default = t.Anime = void 0;
  var n = function (e) {
    if (e && e.__esModule) return e;
    if (null === e || "object" !== l(e) && "function" != typeof e) return {
      default: e
    };
    var t = function () {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return function () {
        return e;
      }, e;
    }();
    if (t && t.has(e)) return t.get(e);
    var r = {},
      n = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
      var u = n ? Object.getOwnPropertyDescriptor(e, o) : null;
      u && (u.get || u.set) ? Object.defineProperty(r, o, u) : r[o] = e[o];
    }
    return r.default = e, t && t.set(e, r), r;
  }(r(1));
  function o(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function u(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  function i(e) {
    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function a(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function c(e, t) {
    return (c = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function f(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function l(e) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var p = function (e) {
    return e;
  };
  if (t.anime = p, "undefined" != typeof window) {
    var s = r(2);
    t.anime = p = "object" === l(s) ? s.default : s;
  }
  var y = function () {
      function e(t) {
        var r, n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this, n = i(e).call(this, t), r = !n || "object" !== l(n) && "function" != typeof n ? a(this) : n, f(a(r), "createAnime", function () {
          var e = r.props;
          0 < r.targets.length && void 0 !== r.anime && p.remove(r.targets);
          var t = !0,
            n = !(r.targets = []),
            u = void 0;
          try {
            for (var i, a = r.targetRefs[Symbol.iterator](); !(t = (i = a.next()).done); t = !0) {
              var c = i.value;
              c.current && r.targets.push(c.current);
            }
          } catch (e) {
            n = !0, u = e;
          } finally {
            try {
              t || null == a.return || a.return();
            } finally {
              if (n) throw u;
            }
          }
          var l = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? o(Object(r), !0).forEach(function (t) {
                f(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({}, e, {
            targets: r.targets
          });
          delete l.children, delete l.svg, r.anime = p(l);
        }), r.targets = [], r.targetRefs = [], r.anime = null, r;
      }
      var t, r;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && c(e, t);
      }(e, n.Component), t = e, (r = [{
        key: "componentDidMount",
        value: function () {
          this.createAnime();
        }
      }, {
        key: "componentDidUpdate",
        value: function () {
          this.createAnime();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
            t = this.props.children,
            r = this.targetRefs;
          return Array.isArray(t) || (t = [t]), n.default.createElement(n.Fragment, null, t.map(function (t, o) {
            r.push(n.default.createRef());
            var u = e.props.svg ? "g" : "div";
            return n.default.createElement(u, {
              ref: r[r.length - 1],
              key: "".concat("__anime__").concat(o)
            }, t);
          }));
        }
      }]) && u(t.prototype, r), e;
    }(),
    b = t.Anime = y;
  t.default = b;
}, function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("animejs");
}]);